var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-link',_vm._g(_vm._b({attrs:{"href":_vm.compiledHref}},'gl-link',_vm.attributes,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }